// @flow

import { StackProps } from "@chakra-ui/react";

export const container: StackProps = {
  width: "100%"
};
